import { BoxProps } from '../BoxNew'

const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 0,
    height: 1,
  },
  shadowOpacity: 0.22,
  shadowRadius: 2.22,
  elevation: 3,
}

const styles = {
  container: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    flex: 1,
    justifyContent: 'flex-start',
    zIndex: 1,
    underlayColor: 'TRANSPARENT',
  } as BoxProps,
  contentViewStyle: {
    overflow: 'auto',
    bg: 'WHITE',
    borderRadius: 5,
    alignSelf: 'flex-start',
    borderColor: 'GREY_1_SEPARATOR',
    borderWidth: 1,
    zIndex: 10,
  } as BoxProps,
  listStyle: {
    ...shadow,
  } as BoxProps,
  apply: {
    padding: 8,
    borderRadius: 4,
    bg: 'PRIMARY',
    align: 'center',
    justifyContent: 'center',
    underlayColor: 'PRIMARY_STORNG',
  } as BoxProps,
  cancel: {
    padding: 8,
    borderRadius: 4,
    bg: 'GRAY_HALF',
    align: 'center',
    justifyContent: 'center',
    underlayColor: 'LIGHTEST_GREY',
  } as BoxProps,
  itemView: {
    backgroundColor: 'WHITE',
    paddingHorizontal: 16,
    paddingVertical: 8,
    underlayColor: 'LIGHTEST_GREY',
    flexDirection: 'row',
    align: 'center',
  } as BoxProps,
}
export default styles
